<script setup>
import WhatsAppTemplateParser from 'dashboard/components-next/whatsapp/WhatsAppTemplateParser.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

defineProps({
  template: {
    type: Object,
    default: () => ({}),
  },
  contextVariables: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['sendMessage', 'replaceMessage', 'resetTemplate']);

const handleSendMessage = payload => {
  emit('sendMessage', payload);
};

const handleReplaceMessage = payload => {
  emit('replaceMessage', payload);
};

const handleResetTemplate = () => {
  emit('resetTemplate');
};
</script>

<template>
  <div class="w-full">
    <WhatsAppTemplateParser
      :template="template"
      :context-variables="contextVariables"
      @send-message="handleSendMessage"
      @replace-message="handleReplaceMessage"
      @reset-template="handleResetTemplate"
    >
      <template
        #actions="{ sendMessage, replaceMessage, resetTemplate, disabled }"
      >
        <footer
          class="sticky bottom-0 z-10 flex gap-2 justify-end pt-4 mt-4 border-t border-n-weak bg-n-solid-1"
        >
          <NextButton
            faded
            slate
            type="reset"
            label="Alterar modelo"
            @click="resetTemplate"
          />
          <NextButton
            faded
            type="button"
            label="Substituir mensagem ativa"
            @click="replaceMessage"
          />
          <NextButton
            type="button"
            :label="$t('WHATSAPP_TEMPLATES.PARSER.SEND_MESSAGE_LABEL')"
            :disabled="disabled"
            @click="sendMessage"
          />
        </footer>
      </template>
    </WhatsAppTemplateParser>
  </div>
</template>
